function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import styled, { withTheme } from 'styled-components';
import { Box, TextInput, Button } from 'grommet';
import { Hide } from 'grommet-icons/icons/Hide';
import { FormView } from 'grommet-icons/icons/FormView';
import PropTypes from 'prop-types';
const ButtonWrap = styled(Button)`
  position: absolute;
  right: 0px;
  &:focus {
    outline: none;
    box-shadow: none;
  }
`;
const StyledTextInput = styled(TextInput)`
  &:focus {
    outline: none;
    box-shadow: none;
  }
  &::-ms-reveal {	
    display: none;	
  }
`;
const PasswordInput = ({
  error,
  theme,
  style,
  onBlur,
  ...rest
}) => {
  const [reveal, setReveal] = useState(false);
  // FIXME: pad should not be used
  return /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    align: "center",
    round: "xsmall",
    background: "white",
    pad: "hair",
    style: {
      position: 'relative',
      ...style
    },
    type: reveal ? 'text' : 'password'
  }, /*#__PURE__*/React.createElement(StyledTextInput, _extends({
    onBlur: onBlur,
    plain: true
  }, rest, {
    type: reveal ? 'text' : 'password'
  })), /*#__PURE__*/React.createElement(ButtonWrap, {
    icon: reveal ? /*#__PURE__*/React.createElement(FormView, {
      size: "medium"
    }) : /*#__PURE__*/React.createElement(Hide, {
      size: "medium"
    }),
    onClick: () => setReveal(!reveal),
    style: {
      padding: '8px'
    }
  }));
};
PasswordInput.defaultProps = {
  error: null,
  theme: null
};
PasswordInput.propTypes = {
  error: PropTypes.string,
  theme: PropTypes.object
};
export default withTheme(PasswordInput);